import React from 'react';

function Divider() {
  return <span style={{padding: 10}} />;
}

export default Divider;
